import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import { formatRoute } from 'react-router-named-routes'
import { LanguageConsumer } from '../../context/LanguageContext'
import SingleLateSubmissionPageContent from '../../components/SingleLateSubmissionPageContent'
import UnAuthorize from '../../components/UnAuthorize'
import { LateSubmissionViewConsumer, LateSubmissionViewProvider } from '../../context/LateSubmissionViewContext'

const SingleLateSubmission = () => {
    const intl = useIntl()
    let { id } = useParams()

    return (
        !!id ? <>
            <SEO title={intl.formatMessage({ id: 'Page.lateSubmissionSingle.title' }, { uuid: id })}
                pathname={window.location.origin + formatRoute(NamedRoutes.singleLateSubmission, { id: id })}
                titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
                description={intl.formatMessage({ id: 'Page.lateSubmissionSingle.title' }, { uuid: id })}
            />

            <AccountLayout content={
                <LanguageConsumer>
                    {({ locale }) => (
                        <LateSubmissionViewProvider id={id} locale={locale}>
                            <LateSubmissionViewConsumer>
                                {({ isUnauthorized }) => (
                                    !!isUnauthorized ? <UnAuthorize /> :
                                        <SingleLateSubmissionPageContent locale={locale} />
                                )}
                            </LateSubmissionViewConsumer>
                        </LateSubmissionViewProvider>
                    )}
                </LanguageConsumer>
            } />
        </>
            :
            <Redirect to={NamedRoutes.lateSubmission} />
    )
}

export default SingleLateSubmission
